import { useLanguage } from "../context/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="servizi" data-testid="services-section" className="py-24 sm:py-36 bg-travertine">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <Reveal>
          <Overline>{t.services.overline}</Overline>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink mt-4">
            {t.services.title}
          </h2>
        </Reveal>

        <div className="mt-16 border-t border-ink/10">
          {t.services.items.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06} y={24}>
              <div
                data-testid={`service-item-${i}`}
                className="group grid sm:grid-cols-12 gap-3 sm:gap-6 items-baseline py-7 border-b border-ink/10 hover:bg-travertine-light/60 transition-colors duration-500 px-2 sm:px-4"
              >
                <span className="sm:col-span-1 font-mono text-xs text-gold tracking-[0.2em]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="sm:col-span-5 font-serif text-2xl lg:text-3xl text-ink group-hover:translate-x-2 transition-transform duration-500">
                  {s.title}
                </h3>
                <p className="sm:col-span-6 text-sm leading-relaxed text-ink/55">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
